import styled, { breakpoints } from '../../styles/theme';
import { rem } from 'polished';
import media from '../../styles/media';
import CharacteristicsTemplate from './CharacteristicsTemplate';
import { CharacteristicsProps } from './index';

export const CharacteristicsStyled = styled(CharacteristicsTemplate)`
    background: ${({ theme }) => theme.colors.white};
    width: 100%;

    .details {
        padding-top: ${rem(10)};
        @media screen and (min-width: ${breakpoints.md}px) {
            display: flex;
        }

        .tech,
        .benefits {
            padding: 0;

            .technicalWrapper {
                border-bottom: none;
            }
        }

        .is-open {
            margin-bottom: ${rem(10)};
        }

        .collapsibleTriggerHeader {
            @media screen and (min-width: ${breakpoints.md}px) {
                display: none;
            }
        }

        .tech-point {
            padding-bottom: ${rem(10)};
            color: ${({ theme }) => theme.colors.black};

            span {
                font-size: ${({ theme }) => theme.fontSizes.textBase};
                display: block;
            }
        }

        .bullet-points {
            padding: 0 ${rem(20)};
            margin: 0;

            li {
                color: ${({ theme }) => theme.colors.black};
                font-size: ${({ theme }) => theme.fontSizes.textBase};
                padding-bottom: ${rem(5)};
            }
        }
    }

    .characteristicsGrid {
        padding-left: 0;
        padding-right: 0;
        width: 100%;
    }

    .characteristics-col-title {
        flex: unset;
        display: flex;
    }

    .vertical {
        margin-top: unset;
        margin-bottom: unset;
    }

    .featureListKey {
        display: block;
    }

    .featureListValue {
        display: block;
        font-size: ${({ theme }) => theme.fontSizes.textBig};
        font-weight: ${({ theme }) => theme.fontWeights.textBold};
        padding: ${rem(5)} 0;
    }

    .featureListWrapper {
        padding-bottom: ${rem(10)};
    }

    .characteristics-grid-col {
        flex: auto;
    }

    .technicalTitle {
        font-size: ${({ theme }) => theme.fontSizes.textBig};
        font-weight: bold;
        line-height: ${({ theme }) => theme.lineHeights.textBig};
        text-transform: uppercase;
        margin: ${rem(60)} 0 ${rem(15)} 0;
        display: block;
        padding: 0 ${rem(10)};

        @media screen and (min-width: ${breakpoints.sm}px) {
            padding: 0;
        }
    }

    .technicalSubtitle {
        font-size: ${({ theme }) => theme.fontSizes.textMedium};
        line-height: ${({ theme }) => theme.lineHeights.textMedium};
        text-transform: uppercase;
        padding: 0 ${rem(10)};

        @media screen and (min-width: ${breakpoints.sm}px) {
            padding: 0;
        }

        & > span {
            border-right: ${rem(2)} solid black;
            padding-left: ${rem(5)};
            padding-right: ${rem(5)};
        }

        & > span:first-child {
            padding-left: 0;
        }

        & > span:last-child {
            border-right: 0;
            padding-right: 0;
        }
    }

    .environmentalWrapper {
        display: block;
        margin: ${rem(15)} 0 ${rem(30)};
        padding-left: ${rem(10)};
        padding-right: ${rem(10)};
        background: ${({ theme }) => theme.colors.grey7};

        div:first-of-type .environmentalBlock {
            border-bottom: 2px solid ${({ theme }) => theme.colors.grey2};
        }

        & > div {
            max-width: 100%;
            ${(prop) => ((prop as CharacteristicsProps).isInnered ? `max-width: 100%;` : ``)};
        }

        ${(prop) =>
            (prop as CharacteristicsProps).isInnered
                ? ``
                : `@media (min-width: ${breakpoints.md}px) {
                    padding: ${rem(30)} 0;
                    margin: ${rem(20)} 0 ${rem(30)};
                    display: flex;
        
                    & > div {
                        width: 100%;
                    }
        
                    div:first-of-type .environmentalBlock {
                        border-bottom: none;
                    }
        
                    div:first-of-type .environmentalBlock {
                        border-right: ${rem(2)} solid #cdcdcd;
                    }
                }`};
    }

    .environmentalBlock {
        max-width: 100%;
        display: flex;
        flex-direction: column;
        padding-left: 0;
        padding-right: 0;
        padding-top: ${rem(15)};
        padding-bottom: ${rem(15)};

        ${media.xs`
            flex-direction: row;
            justify-content: space-between;

        `}

        ${(prop) =>
            (prop as CharacteristicsProps).isInnered
                ? ``
                : `
                ${media.md`
                    padding-top: 0;
                    padding-bottom: 0;

                `}`};

        & > div {
            padding-left: 0;
            padding-right: 0;
        }

        span {
            font-size: ${({ theme }) => theme.fontSizes.textBase};
            color: ${({ theme }) => theme.colors.grey2};
        }

        &:last-child {
            ${media.md`
                border-bottom: none;

            `}

            & > div {
                padding-left: ${rem(10)};
                padding-right: ${rem(10)};
            }
        }
    }

    .environmentalItem {
        margin-bottom: ${rem(10)};
    }

    .techLabel {
        font-size: ${({ theme }) => theme.fontSizes.textMedium};
        font-weight: bold;
        text-transform: uppercase;
        margin-bottom: ${rem(10)};
        display: flex;

        span {
            font-size: ${rem(16)};
        }
    }

    .environmentalLabel {
        margin-top: ${rem(7)};
        font-weight: bold;
        display: flex;
        align-items: center;
    }

    .techImage {
        width: auto;
    }

    .techBlock {
        display: flex;
        align-items: flex-start;
        margin-bottom: ${rem(10)};

        ${media.md`
            margin-bottom: 0;
        `}

        svg {
            margin-top: ${rem(5)};
        }
    }

    .technicalDetails {
        font-size: ${({ theme }) => theme.fontSizes.textBig};
        line-height: ${({ theme }) => theme.lineHeights.textBig};
        font-weight: normal;
        display: flex;
        margin-bottom: ${rem(8)};
        text-transform: uppercase;
        padding: 0 ${rem(10)};

        &-mainBlock {
            padding-left: ${rem(20)};
            @media (max-width: ${breakpoints.sm}px) {
                padding-right: ${rem(20)};
            }
            margin-bottom: ${rem(20)};
        }
    }

    .technicalFeaturesModuleWrap {
        display: block;

        @media (min-width: ${breakpoints.sm}px) {
            display: flex;
            justify-content: space-between;
        }
    }

    .technicalFeaturesModule {
        padding-bottom: ${rem(15)};
        @media (min-width: ${breakpoints.sm}px) {
            width: ${rem(250)};
        }
    }

    @media (min-width: ${breakpoints.sm}px) {
        .technicalFeaturesContainer,
        .technicalFeaturesContainer div {
            width: 100%;
        }
    }

    .technicalFeaturesContainer {
        @media (max-width: ${breakpoints.sm}px) {
            display: block;
            width: 100%;
            padding-top: ${rem(10)};
        }
    }

    .featureList {
        padding: 0 ${rem(1)} ${rem(20)};
        margin-bottom: ${rem(19)};
        color: ${({ theme }) => theme.colors.grey10};
        li {
            font-size: ${({ theme }) => theme.fontSizes.textBase};
            line-height: ${({ theme }) => theme.lineHeights.textBig};
            color: ${({ theme }) => theme.colors.blue1};
            position: relative;
            display: flex;
            align-items: flex-start;
            @media (max-width: ${breakpoints.sm}px) {
                column-gap: ${rem(10)};
                margin-left: ${rem(-10)};
                padding-right: ${rem(10)};
            }

            &::before {
                min-width: ${rem(3)};
                height: ${rem(3)};
                content: '';
                border-radius: 50%;
                background: $darkColor;
                display: inline-block;
                vertical-align: middle;
                margin-right: ${rem(8)};
                margin-top: ${rem(11)};
                align-self: flex-start;
            }
        }
    }

    .featureImageList {
        width: 50%;
    }

    .featureItemList {
        font-size: ${({ theme }) => theme.fontSizes.textMedium};

        li {
            padding: ${rem(5)} 0;
        }
    }

    .legalTextContainer {
        flex: 0 0 100%;
    }

    .legalText {
        font-size: ${({ theme }) => theme.fontSizes.textSmall};
        line-height: ${({ theme }) => theme.lineHeights.textBig};
        color: ${({ theme }) => theme.colors.grey2};
        margin: ${rem(25)} 0;
        display: flex;
    }

    .specificationWrapper {
        justify-content: space-between;

        .featureList {
            margin-bottom: ${rem(1)};

            &:nth-last-of-type() {
                margin-bottom: none;
            }
        }
    }

    .specificationBlock {
        position: relative;
        margin-top: ${rem(-1)};
        padding-left: ${rem(20)};
        padding-bottom: ${rem(10)};

        @media (max-width: ${breakpoints.sm}px) {
            padding-right: ${rem(20)};
        }

        ${media.xs`
            column-gap: 18%;
            columns: 2;
                &:before {
                content: '';
                display: block;
                height: ${rem(1)};
                background: ${rem(1)} solid white;
                left: 0;
                right: 0;
                position: absolute;
            }
            border-bottom: ${rem(1)} solid #ECECEC;
        `}
    }

    .techSpecificationBlock {
        .technicalWrapper {
            li:before {
                display: none;
            }
        }
    }

    .technicalWrapper {
        display: inline-block;
        width: 100%;

        .Collapsible > .is-open {
            svg {
                transform: rotate(180deg);
            }
        }

        ${media.xs`
            padding-top: ${rem(20)};
            border-top: ${rem(1)} solid #ECECEC;
        `}
    }

    .technicalWrapperLight {
        padding-bottom: ${rem(7)};
        color: ${({ theme }) => theme.colors.grey1};
    }

    .featureTitle {
        font-size: ${({ theme }) => theme.fontSizes.textMedium};
        line-height: ${({ theme }) => theme.lineHeights.textBig};
        text-transform: uppercase;
        padding: 0 ${rem(10)};

        @media screen and (min-width: ${breakpoints.xs}px) {
            margin-bottom: ${rem(5)};
        }

        @media screen and (min-width: ${breakpoints.sm}px) {
            padding: 0;
        }
    }

    .featureTitleWide {
        font-size: ${({ theme }) => theme.fontSizes.textMedium};
        line-height: ${({ theme }) => theme.lineHeights.textBig};
        text-transform: uppercase;
        padding: 0 ${rem(10)};

        @media screen and (min-width: ${breakpoints.xs}px) {
            border-top: ${rem(1)} solid #ececee;
            margin-top: ${rem(20)};
            margin-bottom: ${rem(5)};
        }

        @media screen and (min-width: ${breakpoints.sm}px) {
            padding: ${rem(20)} 0 0 0;
        }

        ${(prop) =>
            (prop as CharacteristicsProps).isInnered
                ? `
                    @media screen and (min-width: ${breakpoints.xs}px) {
                        margin-top: 0;
                        padding-top: 0;
                    }
                `
                : ``};
    }

    .featureInfo + .featureValue {
        width: 50%;
    }

    .featureValue {
        margin-left: auto;
        text-align: right;
        font-weight: bold;
        color: ${({ theme }) => theme.colors.black};
    }

    .hideTechnicalDetail {
        text-align: center;
        padding-top: 2rem;
        padding-bottom: 3rem;
        outline: 0;

        a {
            cursor: pointer;
            color: ${({ theme }) => theme.colors.primary};
        }

        :global button > span {
            color: #007edb !important;
        }

        svg {
            transform: translateX(-50%) rotate(270deg);
            color: ${({ theme }) => theme.colors.grey4};
            position: relative;
            left: ${rem(20)};
        }
    }

    .Collapsible {
        background-color: ${({ theme }) => theme.colors.white};
        margin-bottom: ${rem(5)};
    }

    .Collapsible__contentInner {
        display: block;
        text-align: justify;

        .Collapsible__trigger {
            background: ${({ theme }) => theme.colors.white};
        }

        p {
            color: ${({ theme }) => theme.colors.default};
        }
    }

    .Collapsible__trigger {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 1.05rem 1rem 1rem;
        background: #f1f3f2;
        color: ${({ theme }) => theme.colors.default};
        letter-spacing: 0.05rem;
        user-select: none;
        text-transform: uppercase;
        cursor: pointer;
        position: relative;

        ${media.xs`
            background: transparent;
        `}
    }

    .collapsibleTriggerHeader {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;

        & svg > path {
            fill: ${({ theme }) => theme.colors.primary};
        }

        @media (min-width: ${breakpoints.xs}px) {
            & .icon-wrapper {
                display: none;
            }
        }
    }

    .Collapsible__trigger.is-open:after {
        transform: rotate(0);
    }

    .tires-icon.icon-wrapper svg {
        width: ${rem(16)};
        height: ${rem(16)};
        position: relative;
        top: ${rem(3)};
        left: ${rem(5)};
        cursor: pointer;
    }
`;
